import React,{useEffect,useState} from 'react';
import { Grid,Box, Typography,Button} from '@mui/material';
import { Formik,Form } from 'formik';
import { useSelector } from 'react-redux';
import DyButton from '../../components/GlobalComponents/DyButton/DyButton';
import { addLicenseFace } from '../CompanyManagment/Interfaces/Interfaces';
import FormikControl from '../../components/FormikControls/FormikControl';
import {useGetTenants} from './Hooks/index'
// import SearchIcon from '@mui/icons-material/Search';
import DYToastMessage from '../../components/GlobalComponents/DyToastMessage/DYToastMessage';
// import DyButton from '../../../../components/GlobalComponents/DyButton/DyButton';
// import {FormControl,InputLabel,Select,MenuItem,
    // TextField, IconButton } from '@mui/material';
// import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useAddLicense ,useDeailyReport} from '../CompanyManagment/Hooks/index';
// import InputAdornment from '@mui/material/InputAdornment';

const DeailyReport = ({initialValue,editMode,onClose,setShowToastMessage,setAddStaffState}:any) => {

  const userId:string=useSelector((state:any)=>state.loign.userInfo.userId);
  const {data:dataa}=useDeailyReport(userId);
  const LicenseInitialValues:addLicenseFace={
    ceoCode:'',
    phoneNumber:'',
    personCount:'',
    fromDate:'',
    toDate:'',
    Strategy:false,
    Bank:false,
    update:false,
    BAU:false
}
  
  return (
    <Grid container spacing={2}>
    <Grid item xs={12}>
        <Box display="flex" flexDirection="column" p={2} borderRadius={2} boxShadow={3}>
        {[
            { label: 'تعداد ثبت نام شرکت', value: dataa?.tenant },
            { label: 'تعداد هدف', value: dataa?.objectives },
            { label: 'تعداد نتیجه', value: dataa?.keyResult },
            { label: 'تعداد پرسنل ثبت نام شده', value: dataa?.person },
            { label: 'تعداد پرسنل دعوت شده', value: dataa?.invite },
            { label: 'تعداد تیم', value: dataa?.team },
            { label: 'تعداد جلسه', value: dataa?.meet },
            { label: 'تعداد ارزیابی ثبت شده', value: dataa?.checkin },
            { label: 'تعداد شاخص', value: dataa?.index },
            { label: 'تعداد BAU', value: dataa?.bau },
            { label: 'تعداد لاگین به ازای هر حساب', value: dataa?.login }
        ].map((item, index) => (
            <Box
            key={index}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            mb={1}
            p={1}
            bgcolor={index % 2 === 0 ? '#f0f8ff' : '#ffffff'}
            borderRadius={1}
            border="1px solid #00387C" 
            >
            <Typography fontWeight={800} color="#00387C">
                {item.label}:
            </Typography>
            <Box 
                p={1}
                // border="1px solid #00387C" 
                borderRadius={1} 
                bgcolor="#f9f9f9"
                display="flex"
                justifyContent="center"
                alignItems="center"
                minWidth="50px"
            >
                <Typography fontSize="16px" color="#555">
                {item.value}
                </Typography>
            </Box>
            </Box>
        ))}
        </Box>
    </Grid>
    </Grid>
  )
}

export default DeailyReport